export { default } from './ProductAdvices';
